import React from "react";
import FruitItem from "./FruitItem";
import { useDrop } from "react-dnd";

const FruitStand = ({ fruits, onAdd, onRemove }) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: ['FRUIT', 'BASKET_FRUIT'], // Accept both add and remove drags
    drop: (item) => {
      if (item.name) {
        // When dragging from basket, remove fruit
        onRemove(item.name);
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  return (
    <div
      className="fruit-stand"
      ref={drop}
      style={{ backgroundColor: isOver ? '#f0fdf0' : 'transparent' }}
    >
      {fruits.map((fruit) => (
        <div
          key={fruit.name}
          style={{ cursor: "pointer" }}
        >
          <FruitItem fruit={fruit} onAdd={onAdd} />
        </div>
      ))}
    </div>
  );
};

export default FruitStand;
